export default "__VITE_ASSET__acea33bd__"